var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z",
    fill: "#EF6C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.394c.276 0 .5.207.5.462v5.076c0 .255-.224.462-.5.462s-.5-.207-.5-.462V3.856c0-.255.224-.462.5-.462Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12.136,
    fill: "#fff",
    r: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgWarningCircle;